import { Brand } from 'AppBranding';
import angularModule from './front_royal_config_module';

// iguana service wrapper class
// currently only opening up /api/users.json which returns info about the current user
angularModule.factory('Config', [
    '$injector',
    $injector => {
        const Iguana = $injector.get('Iguana');

        return Iguana.subclass(function factory() {
            this.setCollection('config');
            this.alias('Config');
            return {
                httpQueueEventsEnabled() {
                    return this.http_queue_events_enabled === 'true';
                },
                forceIdpInitiatedLoginUrlFor(provider) {
                    return this.force_idp_initiated_login_urls[provider];
                },
                defaultPageMetadata() {
                    return this.default_page_metadata;
                },
                creditCardPaymentFeeRate() {
                    return this.credit_card_payment_fee_rate;
                },
                gdprAppliesToUser() {
                    return this.gdpr_user === 'true';
                },
                enableLessonHexagonNavigation() {
                    return this.enable_lesson_hexagon_navigation === 'true';
                },
                appEnvType() {
                    const appEnvName = this.app_env_name || '';
                    if (appEnvName.match(/production/i)) {
                        return 'production';
                    }
                    if (appEnvName.match(/staging/i)) {
                        return 'staging';
                    }
                    return 'development';
                },
                isQuantic() {
                    return this.is_quantic === 'true';
                },
                statsigClientKey() {
                    return this.statsig_client_key;
                },
                isAlternativeStagingEnvironment() {
                    return this.is_alternative_staging_environment === 'true';
                },
                contentViewsRefreshUpdatedAt() {
                    return this.content_views_refresh_updated_at;
                },
                tutorBotOrigin() {
                    return this.tutor_bot_origin;
                },
                tutorBotSmartlyOrigin() {
                    return this.tutor_bot_smartly_origin;
                },
                tutorBotDisabled() {
                    return this.disable_tutor_bot === 'true';
                },
                tutorBotAccessHeaders() {
                    return {
                        'CF-Access-Client-Id': this.cf_access_client_id,
                        'CF-Access-Client-Secret': this.cf_access_client_secret,
                    };
                },
                debugFrameNavPerf() {
                    return this.debug_frame_nav_perf === 'true';
                },
                biosigEnabled() {
                    // Handle both string and boolean during transition
                    return this.biosig_enabled === 'true' || this.biosig_enabled === true;
                },
                flushEventsDelayMs() {
                    return this.flush_events_delay_ms;
                },
                preRecordedInterviewUrls() {
                    return {
                        [Brand.quantic]: this.pre_recorded_interview_url,
                        [Brand.valar]: this.pre_recorded_interview_url_valar,
                    };
                },
                sendbirdApplicationId() {
                    return this.sendbird_application_id;
                },
                showNonComponentizedFramesInEditor() {
                    return this.show_non_componentized_frames_in_editor === 'true';
                },
                liveKitServerUrl() {
                    return this.live_kit_server_url;
                },
                enableAlumniSelectProgram() {
                    return this.enable_alumni_select_program === 'true';
                },
            };
        });
    },
]);
